import React from 'react';

type Props = {
  imageUrl: string;
  title: string;
  linkUrl: string;
  altText: string;
  trackingCallback(event: string, params?: Record<string, unknown>): void;
};

export const ArticleCard = ({ imageUrl, linkUrl, title, altText, trackingCallback }: Props): JSX.Element => {
  const classes = 'rounded-xl h-full w-full object-cover';

  const handleClick = (): void => {
    const trackingProps = {
      elementId: 'article-card',
      title,
    };
    trackingCallback('clicked-button', trackingProps);
  }

  return (
    <div className='w-40'>
      <a href={linkUrl} target='_blank' onClick={handleClick} rel='noreferrer'>
        <div className='pb-2 w-40 h-28'>
          <img src={imageUrl} className={classes} alt={altText} loading='lazy'/>
        </div>
        <p className='font-bold leading-tight text-xs'>{title}</p>
      </a>
    </div>
  );
};
